import React, { useEffect, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import axios from "axios";
import {
  GetAllPermission,
  GET_ALL_ROLES,
  SYNC_PERMISSION_TO_ROLL,
} from "../../URLs/Apis";
import EdatIcon from "../../assets/svg/Edit.svg";
import { Modal } from "react-bootstrap";
import { Checkbox, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import useDebounce from "../../hooks/useDebounce";

function Roles() {
  const { user } = useSelector((state) => state.auth);
  const headers = {
    Authorization: "Bearer " + user?.token,
  }; // auth header with bearer token

  //Filter the orders
  const [searchForPermissions, setSearchForPermissions] = useState("");
  useEffect(() => {
    getRolesData();
    getPermissionsData();
  }, []);

  const [permissionsData, setPermissionsData] = useState([]);
  const getPermissionsData = () => {
    axios
      .get(GetAllPermission, { headers })
      .then((response) => {
        setPermissionsData(response.data.data.permissions);
      })
      .catch((error) => {
        console.log(error.data);
      });
  };

  const [rolesData, setRolesData] = useState([]);
  const getRolesData = () => {
    axios
      .get(GET_ALL_ROLES, { headers })
      .then((response) => {
        console.log(response.data.data.roles);

        setRolesData(response.data.data.roles);
      })
      .catch((error) => {
        console.log(error.data);
      });
  };
  const debouncedSearchValue = useDebounce(searchForPermissions);

  //Model
  const [show, setShow] = useState(false);
  const Close = () => setShow(false);
  const [checked_AddOrder, setChecked_AddOrder] = useState([]);
  const [updateTheRole, setUpdateTheRole] = useState(null);
  const Open = (data) => {
    setUpdateTheRole(data);
    setChecked_AddOrder(data?.permissions?.map((e) => e.id) || []); // Fallback to empty array
    setShow(true);
  };
  const divStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };
  const handleChangeChecBox = (key) => {
    if (checked_AddOrder?.filter((e) => e === key)[0]) {
      setChecked_AddOrder(checked_AddOrder.filter((e) => e !== key));
      return;
    }
    setChecked_AddOrder((prev) => [...prev, key]);
  };
  const [theOneWillShowPermissionsID, settheOneWillShowPermissionsID] =
    useState("");
  const theOneWillShowPermissions = (id) => {
    console.log(theOneWillShowPermissionsID);
    if (theOneWillShowPermissionsID === id)
      return settheOneWillShowPermissionsID(null);
    settheOneWillShowPermissionsID(id);
  };
  const SaveThePermishan = () => {
    const body = {
      role: updateTheRole.id,
      permissions: checked_AddOrder,
    };
    const rolePermissions = updateTheRole.permissions.map((e) => e.id);
    const validation = checked_AddOrder.every((e) =>
      rolePermissions.includes(e)
    );
    if (validation && rolePermissions.length === checked_AddOrder.length) {
      console.log(validation);
      console.log(rolePermissions);
      console.log(checked_AddOrder);

      return toast.error("Nothing has been changed from Role");
    }
    axios
      .post(SYNC_PERMISSION_TO_ROLL, body, {
        headers: {
          Authorization: "Bearer " + user?.token,
        },
      })
      .then((response) => {
        toast.success(response.data.message);
        console.log(response);
        setShow(false);
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error.message);
        console.log(error.data);
        setShow(false);
      });
  };

  const [checked_AddOrderAll, setChecked_AddOrderAll] = useState(null);
  const handleChangeChecBoxAll = (event) => {
    if (event.target.checked === false) {
      setChecked_AddOrderAll(false);
      setChecked_AddOrder([]);
      return;
    }
    setChecked_AddOrderAll(event.target.checked || true);
    setChecked_AddOrder(permissionsData.map((e) => (e.id ? e.id : null)));
  };

  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const filteredData = permissionsData.filter((item) => {
    const searchLower = String(searchTerm).toLowerCase();
    const matchesSearch = item.name.toLowerCase().includes(searchLower);
    return matchesSearch;
  });

  return (
    <>
      <Modal
        contentClassName="Roles-content"
        dialogClassName="Roles-dialog"
        show={show}
        onHide={Close}
      >
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="AddStaffModal_title">Edit Role</Modal.Title>
        </Modal.Header>
        <Modal.Body style={divStyle}>
          <div>
            <div className="activationServes activationServes_text">
              Permissions for the role: {updateTheRole?.name}
              <div className="StockPage-serchBar">
                <input
                  type="text"
                  placeholder="Search by permissions name... "
                  value={searchTerm}
                  className="serchAndFilter-input_staffPage"
                  onChange={handleSearchChange}
                  style={{ padding: "10px", width: "300px" }}
                />
                <img
                  src={SearchIcon}
                  alt=""
                  className="serchAndFilter-icon_staffPage"
                />
              </div>
            </div>
            <div className="permissionsItem_Authoriztion_All">
              <Checkbox
                className="p-0"
                checked={checked_AddOrderAll || false} // Fallback to false
                onClick={(e) => handleChangeChecBoxAll(e)}
              />
              Select All Permissions
            </div>
            <div className="allPremishin">
              {filteredData?.map((e, i) => {
                return (
                  <>
                    <div key={e.id} className="permissionsItem_Authoriztion">
                      <Checkbox
                        className="p-0"
                        checked={checked_AddOrder?.includes(e.id) || false} // Fallback to false
                        onClick={() => handleChangeChecBox(e.id)}
                      />
                      {i + 1}. {e.name}
                    </div>
                  </>
                );
              })}
            </div>
          </div>

          <div className="foterAddModel">
            <button type="button" className="closAddModal" onClick={Close}>
              Cancel
            </button>
            <button
              type="submit"
              className="saveAddModeal"
              onClick={SaveThePermishan}
            >
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <div className="MeanContant">
        <div className="w-50 mx-auto mt-3 w-lg-auto">
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="search-brands">
              Search for Role Name ...
            </InputLabel>
            <OutlinedInput
              id="search-brands"
              type="text"
              value={searchForPermissions}
              onChange={(e) => {
                setSearchForPermissions((perv) => (perv = e.target.value));
              }}
              label="Search for Role Name ..."
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
        <div className="RolesList_Authoriztion">
          {rolesData
            ?.filter((e) => e.name.toLowerCase().includes(debouncedSearchValue))
            .map((e) => {
              return (
                <div key={e.id}>
                  <div className="RolesItem_Authoriztion">
                    <div className="title_RolesItem_Authoriztion">
                      {e.name
                        .split("-")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase()
                        )
                        .join(" ")}
                    </div>
                    <div className="EdatShow_RolesItem_Authoriztion">
                      <div
                        onClick={() => Open(e)}
                        className="btn btn-light edit-auth-border"
                      >
                        <img
                          className="dsblayNaneForSmollScren pe-2"
                          src={EdatIcon}
                          alt=""
                        />
                        <span className="text_RolesItem_Authoriztion">
                          Edit
                        </span>
                      </div>
                      <div
                        onClick={() => theOneWillShowPermissions(e.id)}
                        className="border_RolesItem_Authoriztion "
                      >
                        <div className="numP_RolesItem_Authoriztion">
                          {e?.permissions?.length}
                        </div>
                        <span className="text_RolesItem_Authoriztion">
                          Show Permissions
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="permissionsOfRoll_RolesItem_Authoriztion">
                    {e.permissions?.map((j, i) => {
                      return (
                        <>
                          <div
                            key={j.id}
                            className={`${
                              theOneWillShowPermissionsID !== e.id
                                ? "d-none"
                                : ""
                            }`}
                          >
                            {i + 1}.
                            {" " +
                              j.name
                                .split("-")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ")}
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}

export default Roles;
